import React from 'react';
import { isAttachmentLikedBy, likedByIds } from '../../utils/attachmentMediaApi';

/** Small heart badge for liked attachments (group tiles, thumbs, lists). */
const AttachmentLikeHeart = ({
  attachment,
  userId,
  className = '',
  size = 'md',
}) => {
  const count = likedByIds(attachment).length;
  if (count <= 0) return null;
  const likedByMe = isAttachmentLikedBy(attachment, userId);
  const dim = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';
  const pad = size === 'sm' ? 'p-0.5' : 'p-1';

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full bg-black/55 shadow-sm pointer-events-none ${pad} ${
        likedByMe ? 'text-rose-400' : 'text-white'
      } ${className}`}
      title={likedByMe ? `Liked by you${count > 1 ? ` and ${count - 1} other${count === 2 ? '' : 's'}` : ''}` : `${count} like${count === 1 ? '' : 's'}`}
      aria-label={likedByMe ? 'Liked' : `${count} likes`}
    >
      <svg
        className={dim}
        viewBox="0 0 24 24"
        fill={likedByMe ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={likedByMe ? 0 : 2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </span>
  );
};

export default AttachmentLikeHeart;
